// Port of api/fuel/app/classes/filter/search/games/rules/query/bgg_age.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'bgg_age',
	field: function() { return 'g.game_age_community' }
})
